import BoxDecouverte from "../../components/categories/BoxDecouverte";

const BoxDecouvertePage = () => {
  return (
    <div className="section-padding">
      <BoxDecouverte />
    </div>
  );
};

export default BoxDecouvertePage;